var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filters-multiselect',{attrs:{"placeholder":_vm.$t('applications'),"multiple":true,"model":_vm.searchAppValue,"options":_vm.appsList},on:{"searchItem":_vm.appPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }